import {html, css, LitElement} from 'lit';


export class DzCustomEvent extends LitElement {

    static properties = {
        name:       {type: String},
        detail:     {type: String},
        default:    {type: Boolean, reflect: true },
    }

    constructor() {
        super()
        this.default = false
    }

    connectedCallback() {
        super.connectedCallback()
        if (this.default) {
            this.dispatch()
        }
    }


    render() {
        return html`
            <slot part="content" @click="${this.dispatch}"></slot>
        `
    }

    dispatch(orig_evt) {
        if (orig_evt) {
            orig_evt.stopPropagation()
        }
        let evt = new CustomEvent(this.name, {bubbles: true, composed: true, detail: this.detail})
        this.dispatchEvent(evt)
    }


    static styles = css`
        slot {
            display: block;
        }
    `
    
}

customElements.define('dz-custom-event', DzCustomEvent)